<ng-container *ngIf="!mortgageApplication.IsFactFind">
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageHomeImprovement']"
    [labelName]="referenceDataLabels.ReMortgageHomeImprovementBTL"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageHomeImprovement" [fieldMaxLength]="6">
  </boi-form-numeric-input>

  <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [isCurrency]="true"
    [propertyNames]="['RemortgageUse.ReMortgageOtherPropertyImprovement']"
    [labelName]="referenceDataLabels.ReMortgageOtherPropertyImprovement"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageOtherPropertyImprovement" [fieldMaxLength]="6">
  </boi-form-numeric-input>

  <ng-container
    *ngIf="(mortgageApplication.RemortgageUse.ReMortgageHomeImprovement || mortgageApplication.RemortgageUse.ReMortgageOtherPropertyImprovement) && !mortgageApplication.IsAip">
    <boi-form-textarea class="medium-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.PleaseProvideDetails"
      [propertyNames]="['RemortgageUse.ReMortgageHomeImprovementDetails']"
      [(value)]="mortgageApplication.RemortgageUse.ReMortgageHomeImprovementDetails" [fieldMaxLength]="1500">
    </boi-form-textarea>
  </ng-container>
</ng-container>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageSchoolFeesOrPension']"
  [labelName]="referenceDataLabels.ReMortgageSchoolFeesOrPension"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageSchoolFeesOrPension" [fieldMaxLength]="6">
</boi-form-numeric-input>

<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageSchoolFeesOrPension && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea" [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageSchoolFeesOrPensionDetails']"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageSchoolFeesOrPensionDetails" [fieldMaxLength]="1500">
  </boi-form-textarea>
</ng-container>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageBusinessInvestment']"
  [labelName]="referenceDataLabels.ReMortgageBusinessInvestment"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageBusinessInvestment" [fieldMaxLength]="6">
</boi-form-numeric-input>

<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageBusinessInvestment && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageBusinessInvestmentDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageBusinessInvestmentDetails" [fieldMaxLength]="1500">
  </boi-form-textarea>
</ng-container>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageAdditionalProperty']"
  [labelName]="referenceDataLabels.ReMortgageAdditionalPropertyBTL"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageAdditionalProperty" [fieldMaxLength]="6">
</boi-form-numeric-input>

<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageAdditionalProperty && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageAdditionalPropertyDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageAdditionalPropertyDetails" [fieldMaxLength]="1500">
  </boi-form-textarea>
</ng-container>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageOutrightPropertyPurchase']"
  [labelName]="referenceDataLabels.ReMortgageOutrightPropertyPurchaseBTL"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageOutrightPropertyPurchase" [fieldMaxLength]="6">
</boi-form-numeric-input>

<ng-container
  *ngIf="mortgageApplication.RemortgageUse.ReMortgageOutrightPropertyPurchase && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageOutrightPropertyPurchaseDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageOutrightPropertyPurchaseDetails" [fieldMaxLength]="1500">
  </boi-form-textarea>
</ng-container>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageLoanRepayment']"
  [labelName]="referenceDataLabels.ReMortgageLoanRepayment"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageLoanRepayment"
  [contextualHelpName]="'AppRemortgageLoanRepayment'" [fieldMaxLength]="6"></boi-form-numeric-input>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageCostsAndFees']"
  [labelName]="referenceDataLabels.ReMortgageCostsAndFees"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageCostsAndFees" [fieldMaxLength]="6"></boi-form-numeric-input>

<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageCostsAndFees && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageCostsAndFeesDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageCostsAndFeesDetails" [fieldMaxLength]="1500">
  </boi-form-textarea>
</ng-container>

<ng-container *ngIf="!mortgageApplication.IsFactFind">
  <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [isCurrency]="true"
    [propertyNames]="['RemortgageUse.RedemptionMortgageOnOtherProperty']"
    [labelName]="referenceDataLabels.RedemptionMortgageOnOtherProperty"
    [(value)]="mortgageApplication.RemortgageUse.RedemptionMortgageOnOtherProperty" [fieldMaxLength]="6">
  </boi-form-numeric-input>

  <ng-container
    *ngIf="mortgageApplication.RemortgageUse.RedemptionMortgageOnOtherProperty && !mortgageApplication.IsAip">
    <boi-form-textarea class="medium-textarea" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.PleaseProvideDetails"
      [propertyNames]="['RemortgageUse.RedemptionMortgageOnOtherPropertyDetails']"
      [(value)]="mortgageApplication.RemortgageUse.RedemptionMortgageOnOtherPropertyDetails" [fieldMaxLength]="1500">
    </boi-form-textarea>
  </ng-container>
</ng-container>

<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.OtherAdditionalRemortgage']"
  [labelName]="referenceDataLabels.OtherAdditionalRemortgage"
  [(value)]="mortgageApplication.RemortgageUse.OtherAdditionalRemortgage" [fieldMaxLength]="6"></boi-form-numeric-input>

<ng-container *ngIf="mortgageApplication.RemortgageUse.OtherAdditionalRemortgage">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.OtherAdditionalRemortgageDetails']"
    [(value)]="mortgageApplication.RemortgageUse.OtherAdditionalRemortgageDetails" [fieldMaxLength]="1500">
  </boi-form-textarea>
</ng-container>